<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		width="22.52"
		height="20.354"
		viewBox="0 0 22.52 20.354"
	>
		<defs>
			<clipPath id="clip-path-DesktopSVG">
				<rect id="Rectangle_5004" data-name="Rectangle 5004" width="22.52" height="20.354" fill="#5e7288" />
			</clipPath>
		</defs>
		<g id="Group_15569" data-name="Group 15569" clip-path="url(#clip-path-DesktopSVG)">
			<path
				id="Path_6474"
				data-name="Path 6474"
				d="M20.138,0H2.382A2.385,2.385,0,0,0,0,2.382v11.26a2.385,2.385,0,0,0,2.382,2.382H8.133L7.44,19.488H5.2a.433.433,0,1,0,0,.866H17.323a.433.433,0,1,0,0-.866H15.079l-.693-3.465h5.751a2.385,2.385,0,0,0,2.382-2.382V2.382A2.385,2.385,0,0,0,20.138,0M8.324,19.488l.693-3.465H13.5l.693,3.465Zm13.33-5.846a1.517,1.517,0,0,1-1.516,1.516H2.382A1.517,1.517,0,0,1,.866,13.642V12.559H21.653v1.083Zm0-1.949H.866V2.382A1.517,1.517,0,0,1,2.382.866H20.138a1.517,1.517,0,0,1,1.516,1.516Z"
				fill="#5e7288"
			/>
			<path
				id="Path_6475"
				data-name="Path 6475"
				d="M243.447,301.947a.578.578,0,1,0,.577.578.578.578,0,0,0-.577-.578"
				transform="translate(-232.188 -288.666)"
				fill="#5e7288"
			/>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'DesktopSVG',
};
</script>

<style scoped lang="scss"></style>
